import { request } from './client';
import type { TenantAuditLogEntry } from '@/generated/ts-rs/TenantAuditLogEntry';

export type AuditEntry = TenantAuditLogEntry;

export function getAuditLog(
  token: string,
  page: number = 1,
  perPage: number = 20,
): Promise<AuditEntry[]> {
  return request('GET', `/api/tenant/audit-log?page=${page}&per_page=${perPage}`, undefined, token);
}
